export default [
  {
    position: "absolute",
    top: 10.7,
    left: 93.5,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "personalDetailsMore.persona1.mTitleOne",
    mBody: "personalDetailsMore.persona1.mBodyOne",
    plusIcon: true,
    isAction: true,
    id: "OB_EditDetails_Action_UpdateInfo",
    index: 0,
  },
  {
    position: "absolute",
    top: 6.2,
    left: 5.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "personalDetailsMore.persona1.ttTextOne",
    hover: false,
    id: "OB_EditDetails_Navigation_Homepage",
    index: 1,
  },
  {
    position: "absolute",
    top: 4.5,
    left: 32.36,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "personalDetailsMore.persona1.ttTextTwo",
    hover: false,
    id: "OB_EditDetails_Navigation_PersonalDetails",
    index: 2,
  },
  {
    position: "absolute",
    top: 4.5,
    left: 60.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "personalDetailsMore.persona1.ttTextThree",
    hover: false,
    id: "OB_EditDetails_Navigation_Policies",
    index: 3,
  },
  {
    position: "absolute",
    top: 4.5,
    left: 69.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "personalDetailsMore.persona1.ttTextFour",
    hover: false,
    id: "OB_EditDetails_Navigation_Feedback",
    index: 4,
  },
  {
    position: "absolute",
    top: 0.6,
    left: 87.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "personalDetailsMore.persona1.ttTextFive",
    hover: false,
    tooltipClass: "left",
    id: "OB_EditDetails_Navigation_Actions",
    index: 5,
  },
];
